import { gql } from "graphql-request";
import MainPhotoFragment from "queries/fragments/MainPhoto";
import ParkLite from "queries/fragments/ParkLite";

export default function ATTRACTIONS_QUERY(
  manufacturerQuery = false,
  typeFilter = false
) {
  const query = gql`
    ${MainPhotoFragment}
    ${ParkLite}

    query Attraction($limit: Int, $start: Int${
      manufacturerQuery ? ", $manufacturer: String" : ""
    }${typeFilter ? ", $type: String" : ""}) {
      attractionsCount${
        manufacturerQuery && !typeFilter
          ? "(where: { Manufacturers: $manufacturer })"
          : ""
      }${typeFilter && !manufacturerQuery ? "(where: { Type: $type })" : ""}${
    typeFilter && manufacturerQuery
      ? "(where: { Type: $type,  Manufacturers: $manufacturer })"
      : ""
  }
      attractions(
        sort: "Slug:asc"
        limit: $limit
        start: $start
        ${
          manufacturerQuery && !typeFilter
            ? "where: { Manufacturers: $manufacturer }"
            : ""
        }
        ${typeFilter && !manufacturerQuery ? "where: { Type: $type }" : ""}
        ${
          typeFilter && manufacturerQuery
            ? "where: { Manufacturers: $manufacturer, Type: $type }"
            : ""
        }
      ) {
        Name
        Slug
        id
        Park {
          ...ParkLite
        }
        CoverPhoto {
          ...MainPhoto
        }
        MainPhoto {
          ...MainPhoto
        }
      }
    }
  `;

  return query;
}
